import { Record } from 'immutable';
import { pickBy, isEmpty } from 'lodash';
import config from 'commons-vehicle/config/index.js';
import URL from 'commons-vehicle/Vehicle/constants/url.js';

const imagesServer = config.source.image;
const imagesBasePath = '/images';
const imageInventoryPath = '/inventory';

function buildImageUrls(imagePath) {
    return {
        url: `${imagesServer}${imagePath || ''}`,
        url360x270: `${imagesServer}/ir/w360h270${imagePath || ''}`,
        url360x240: `${imagesServer}/ir/w360h197c${imagePath || ''}`,
        url440: `${imagesServer}/ir/w440${imagePath || ''}`,
    };
}

function buildInventoryBasePath() {
    return `${imagesBasePath}${imageInventoryPath}`;
}

function buildCatalogWithMatchedCatalogVehicle(matchedCatalogVehicle) {
    if (
        matchedCatalogVehicle &&
        matchedCatalogVehicle.multimedia &&
        matchedCatalogVehicle.multimedia.exteriorPictures
    ) {
        return {
            catalog: matchedCatalogVehicle.multimedia.exteriorPictures,
        };
    }
    return null;
}

const MultiMediaRecord = Record({
    pictures: [],
    mainPicture: {
        url: '',
        url360x270: '',
        url440: '',
    },
    catalog: {
        side: {
            url: '',
            url360x197: '',
            exactMatch: false,
        },
    },
    video: {
        url: '',
    },
});

class MultiMedia extends MultiMediaRecord {
    constructor(obj, matchedCatalogVehicle) {
        const args = pickBy(obj);
        const newArgs = {};

        if (args) {
            if (args.pictures && args.pictures.length) {
                newArgs.pictures = args.pictures.map((picture) => {
                    let newUrl = '';

                    if (picture.url) {
                        newUrl = `${imagesServer}${buildInventoryBasePath()}${picture.url}`;
                    }

                    return {
                        ...picture,
                        url: newUrl,
                        src: newUrl,
                    };
                });
            }

            if (args.mainPicture && args.mainPicture.url) {
                const imagePath = `${buildInventoryBasePath()}${args.mainPicture.url}`;

                newArgs.mainPicture = {
                    ...args.mainPicture,
                    ...buildImageUrls(imagePath),
                };
            }

            if (args.catalog) {
                const imagePath = args.catalog.side && args.catalog.side.url ? args.catalog.side.url : URL.NO_PHOTO;
                const imageUrl = `${imagesBasePath}/${imagePath}`;
                newArgs.catalog = {
                    side: buildImageUrls(imageUrl),
                };
            }
        }

        if (matchedCatalogVehicle) {
            const multimediaCatalog = buildCatalogWithMatchedCatalogVehicle(matchedCatalogVehicle);
            if (multimediaCatalog) {
                newArgs.catalog = multimediaCatalog.catalog;
            }
        }

        super({ ...args, ...newArgs });
    }

    getMainImage() {
        return this.mainPicture && this.mainPicture.url ? this.mainPicture.url : '';
    }

    getMainImage360x270() {
        return this.mainPicture && this.mainPicture.url360x270 ? this.mainPicture.url360x270 : '';
    }

    getMainImage440() {
        return this.mainPicture && this.mainPicture.url440 ? this.mainPicture.url440 : '';
    }

    getCatalogSideImage() {
        return this.catalog && this.catalog.side && this.catalog.side.url ? this.catalog.side.url : '';
    }

    getCatalogSideImage360x197() {
        return this.catalog && this.catalog.side && this.catalog.side.url360x240 ? this.catalog.side.url360x240 : '';
    }

    getPicture(index) {
        // eslint-disable-next-line no-restricted-globals
        if (!isFinite(index) || index < 0 || !this.pictures.length || index > this.pictures.length) {
            return '';
        }

        const picture = this.pictures[index];

        return picture && picture.url ? picture.url : '';
    }

    getVideo() {
        return this.hasVideo() ? this.video.url : '';
    }

    hasPictures() {
        return !isEmpty(this.pictures);
    }

    hasVideo() {
        return !!(this.video && this.video.url);
    }
}

export {
    buildImageUrls,
    buildInventoryBasePath,
    buildCatalogWithMatchedCatalogVehicle,
    imagesServer,
    imagesBasePath,
    imageInventoryPath,
};

export default MultiMedia;



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/Vehicle/models/MultiMediaModel.js